import { forwardRef, type ComponentPropsWithoutRef } from "react";
import { Popover as P } from "radix-ui";
import { cn } from "@/lib/cn";

export const Popover = P.Root;
export const PopoverTrigger = P.Trigger;
export const PopoverAnchor = P.Anchor;
export const PopoverClose = P.Close;

export const PopoverContent = forwardRef<HTMLDivElement, ComponentPropsWithoutRef<typeof P.Content>>(function PopoverContent(
  { className, sideOffset = 8, align = "center", collisionPadding = 12, ...props },
  ref,
) {
  return (
    <P.Portal>
      <P.Content
        ref={ref}
        sideOffset={sideOffset}
        align={align}
        collisionPadding={collisionPadding}
        className={cn("z-50 w-72 rounded-2xl border border-line bg-white p-4 shadow-[0_18px_50px_rgb(15_23_42/0.14)] outline-none data-[state=open]:animate-pop", className)}
        {...props}
      />
    </P.Portal>
  );
});
